// Die Entscheidungs-Regeln am Plugin — EINE Formulierung für alle Sichten.
//
// Vorher stand dasselbe Gate in vier Dateien als je eigener Boolean-Ausdruck (Katalog-Zellen,
// Agent-Sektion, Massen-Freigabe, Freischalten-Dialog). Vier Ausdrücke driften; eine Regel,
// die je nach Bildschirm anders urteilt, ist keine. Die Domänen-Wahrheit liegt im Server —
// hier geht es nur darum, sie VORHER sichtbar zu machen, statt Nutzer in 403er laufen zu
// lassen. Deshalb müssen alle Sichten dieselbe Antwort geben.

export interface PluginGateInput {
  /** available | orphaned | unknown (#287). */
  status: string;
  /** Plattform-Freigabe (#288). */
  approved: boolean;
  ownerAvailable: boolean;
}

/**
 * Freigeben nur gegen ein GELESENES Manifest — Sperren dagegen IMMER, auch bei verwaistem
 * Eintrag oder toter Quelle: das ist der Not-Aus, er darf an keiner fremden Störung hängen.
 */
export function kannFreigabeSchalten(p: PluginGateInput): boolean {
  return p.status === "available" || p.approved;
}

/** Anbieten setzt Freigeben voraus (Domänen-Invariante); Zurücknehmen geht immer. */
export function kannOwnerFreigabeSchalten(p: PluginGateInput): boolean {
  if (p.ownerAvailable) return true; // zurücknehmen — immer
  return p.approved && p.status === "available";
}

/** Zuweisen nur, was freigeSCHALTET (#288) UND im Manifest ist; ABSCHALTEN geht immer. */
export function kannZuweisen(p: PluginGateInput & { enabled: boolean }): boolean {
  if (p.enabled) return true; // abschalten — immer
  return p.approved && p.status === "available";
}

/** Kandidaten der Massen-Freischaltung: noch nicht freigeschaltet, aber freischaltbar. */
export function istFreigabeKandidat(p: PluginGateInput): boolean {
  return !p.approved && p.status === "available";
}
